// src/components/Advantages.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const Advantages = () => {
  const { t } = useTranslation();

  const items = t("advantages.items", { returnObjects: true });

  return (
    <motion.section
      className="bg-[#00172B] py-20 px-6 md:px-20 relative overflow-hidden"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ staggerChildren: 0.2 }}
    >
      <motion.div
        className="max-w-6xl mx-auto text-center"
        variants={fadeIn}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12">
          {t("advantages.heading")}
          <span className="block h-1 w-20 bg-gradient-to-r from-blue-500 to-purple-500 mt-4 mx-auto rounded-full"></span>
        </h2>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((item, index) => (
            <motion.li
              key={index}
              className="flex flex-col items-center bg-[#021E3D] p-8 rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              variants={fadeIn}
              transition={{ duration: 0.6 }}
            >
              <FaCheckCircle className="text-blue-400 text-5xl mb-4 drop-shadow-md" />
              <h3 className="text-white text-xl font-semibold mb-3">{item.title}</h3>
              <p className="text-gray-400 text-center">{item.description}</p>
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </motion.section>
  );
};

export default Advantages;
